var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewDriver1 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27304 2.66303C3.29562 1.56038 4.20935 0.666504 5.31392 0.666504C6.41849 0.666504 7.29562 1.56038 7.27304 2.66303C7.25047 3.76568 6.33673 4.65955 5.23216 4.65955C4.1276 4.65955 3.25047 3.76568 3.27304 2.66303ZM1.80344 9.3181H8.47011C8.70118 9.3174 8.91787 9.19732 9.04276 9.00073C9.16766 8.80415 9.18296 8.5591 9.0832 8.35312L8.47576 7.08865C8.14956 6.41513 7.46709 5.99033 6.71157 5.99056H3.69824C2.94272 5.99033 2.24286 6.41513 1.88909 7.08865L1.22987 8.35312C1.12167 8.5591 1.12693 8.80415 1.24378 9.00073C1.36063 9.19732 1.57239 9.3174 1.80344 9.3181ZM6.84953 10.6491H9.44286C9.53834 10.6399 9.63259 10.6704 9.70327 10.7334C9.77396 10.7964 9.81477 10.8864 9.81605 10.9819L9.76305 13.5707C9.76526 13.7071 9.68206 13.8322 9.55456 13.8842C9.42705 13.9361 9.28222 13.904 9.19161 13.8036L8.53857 13.1381C7.34479 14.4205 5.54989 14.95 3.87915 14.5126C2.20841 14.0753 0.937982 12.7433 0.58122 11.0551C0.564712 10.9567 0.591029 10.8551 0.653609 10.7756C0.717489 10.6953 0.814555 10.6486 0.916198 10.6491H1.58286C1.72401 10.6453 1.85044 10.7306 1.8985 10.8621C2.20195 12.0306 3.12208 12.9285 4.29975 13.2055C5.47742 13.4825 6.72592 13.0945 7.55792 12.1931L6.60462 11.2148C6.51319 11.1197 6.48847 10.9783 6.54177 10.8551C6.59507 10.732 6.71613 10.651 6.84953 10.6491Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewDriver1, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewDriver1.38385a84.svg";
export { ForwardRef as ReactComponent };